import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './About.module.css';
import cssIcon from '../../assets/icons/css-icon.png';
import flutterIcon from '../../assets/icons/flutter-icon.png';
import htmlIcon from '../../assets/icons/html-icon.png';
import mysqlIcon from '../../assets/icons/mysql-icon.png';
import odooIcon from '../../assets/icons/odoo-icon.png';
import phpIcon from '../../assets/icons/php-icon.png';
import pythonIcon from '../../assets/icons/python-icon.png';
import reactIcon from '../../assets/icons/react-icon.png';
import tsIcon from '../../assets/icons/ts-icons.png';
import javaIcon from '../../assets/icons/java-icon.png';
import cppIcon from '../../assets/icons/cpp-icon.png';
import csharpIcon from '../../assets/icons/csharp-icon.png';
import pgIcon from '../../assets/icons/pg-icon.png';
import xmlIcon from '../../assets/icons/xml-icon.png';
import i18n from '../../i18n';
import axios from 'axios';

export const About: React.FC = () => {
  const { t } = useTranslation();
  const [countryCode, setCountryCode] = useState<string | null>(null);

  useEffect(() => {
    axios.get('https://ipapi.co/json/')
      .then((res) => {
        setCountryCode(res.data.country_code);
      })
      .catch((err) => {
        console.error('Failed to fetch country info:', err);
      });
  }, []);

  return (
    <section className={styles.about} id="ueber-mich">
      <div className={styles.container}>
        <h2>{t('about.heading')}</h2>
        <div className={styles.content}>
          <div className={styles.text}>
            <p dangerouslySetInnerHTML={{ __html: t('about.intro') }} />
            <p dangerouslySetInnerHTML={{ __html: t('about.programming') }} />
            <p dangerouslySetInnerHTML={{ __html: t('about.odoo') }} />
            <p dangerouslySetInnerHTML={{ __html: t('about.flutter') }} />
            <p dangerouslySetInnerHTML={{ __html: t('about.bachelor') }} />
            {countryCode === 'DE' && (
              <p dangerouslySetInnerHTML={{ __html: t('about.work') }} />
            )}            <p>{t('about.searching')}</p>
          </div>
          {countryCode && (
            <div className={styles.timeline} dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
              {['degree', 'statmath', 'odoo_work', 'flutter', 'thesis', 'part_time']
                .filter((key) => {
                  if (key === 'part_time' && countryCode !== 'DE') return false;
                  return true;
                })
                .map((key) => (
                  <div className={styles.entry} key={key}>
                    <span className={styles.date}>{t(`about.timeline.${key}.date`)}</span>
                    <div className={styles.desc}>{t(`about.timeline.${key}.desc`)}</div>
                  </div>
                ))}
            </div>
          )}

          <div className={styles.badges}>
            <span><img src={pythonIcon} alt="Python" width="24" height="24" /> {t('about.badges.python')}</span>
            <span><img src={odooIcon} alt="Odoo" width="24" height="24" /> {t('about.badges.odoo')}</span>
            <span><img src={javaIcon} alt="Java" width="24" height="24" /> {t('about.badges.java')}</span>
            <span><img src={cppIcon} alt="C++" width="24" height="24" /> {t('about.badges.cpp')}</span>
            <span><img src={csharpIcon} alt="C#" width="24" height="24" /> {t('about.badges.csharp')}</span>
            <span><img src={phpIcon} alt="PHP" width="24" height="24" /> {t('about.badges.php')}</span>
            <span><img src={reactIcon} alt="React" width="24" height="24" /> {t('about.badges.react')}</span>
            <span><img src={tsIcon} alt="TypeScript" width="24" height="24" /> {t('about.badges.typescript')}</span>
            <span><img src={htmlIcon} alt="HTML" width="24" height="24" /> {t('about.badges.html')}</span>
            <span><img src={xmlIcon} alt="XML" width="24" height="24" /> {t('about.badges.xml')}</span>
            <span><img src={cssIcon} alt="CSS" width="24" height="24" /> {t('about.badges.css')}</span>
            <span><img src={flutterIcon} alt="Flutter" width="24" height="24" /> {t('about.badges.flutter')}</span>
            <span><img src={mysqlIcon} alt="MySQL" width="24" height="24" /> {t('about.badges.mysql')}</span>
            <span><img src={pgIcon} alt="PostgreSQL" width="24" height="24" /> {t('about.badges.postgresql')}</span>
          </div>
        </div>
      </div>
    </section>
  );
};